import { CalendarBooking } from 'generated-graphql/types';
import { User } from 'services/user/types';
import { WhatsaapTemplate } from 'services/whatsaapTemplates/types';

export enum Sender {
  AGENT = 'AGENT',
  PROSPECT = 'PROSPECT',
  USER = 'USER'
}

export enum ConversationStatus {
  CREATED = 'CREATED',
  ONGOING = 'ONGOING',
  COMPLETED = 'COMPLETED',
  COMPLETED_MEETING_REQUESTED = 'COMPLETED_MEETING_REQUESTED',
  COMPLETED_AWAITING_CALL = 'COMPLETED_AWAITING_CALL',
  COMPLETED_CUSTOM_REQUEST = 'COMPLETED_CUSTOM_REQUEST',
  COMPLETED_REJECTED = 'COMPLETED_REJECTED',
  DELIVERY_FAILED = 'DELIVERY_FAILED',
  QUEUED = 'QUEUED',
  OPTED_OUT = 'OPTED_OUT'
}

export enum MessageStatus {
  NOT_SENT = 'NOT_SENT',
  SENT = 'SENT',
  SENT_SUCCESS = 'SENT_SUCCESS',
  READ = 'READ',
  SENT_FAILED = 'SENT_FAILED',
  SENT_SKIPPED = 'SENT_SKIPPED',
  RECEIVED_SUCCESS = 'RECEIVED_SUCCESS'
}

export type Media = {
  classifiedDocumentType: string;
  contentType: string;
  twilioMediaSid: string;
  fileName: string;
};

export type Message = {
  id: string;
  body: string;
  status: MessageStatus;
  conversation?: Conversation | null;
  conversationId?: string | null;
  agentId?: string | null;
  userId?: string | null;
  campaignId?: string | null;
  sender?: Sender | null;
  createdAt: string;
  isInitial?: boolean | null;
  deliveredAt?: string | null;
  readAt?: string | null;
  updatedAt: string;
  twilioErrorCode?: string | null;
  templateId?: string | null;
  template?: WhatsaapTemplate | null;
  emailSubjectLine?: string | null;
  media?: Media;
};

export type ModelAttachmentConnection = {
  items: Array<Attachment>;
  nextToken?: string | null;
};

export type Attachment = {
  id: string;
  conversationId: string;
  conversation?: Conversation | null;
  media: Media;
  createdAt: string;
  updatedAt: string;
};

export enum ScreeningQuestionOutcomeType {
  PASSED = 'PASSED',
  FAILED = 'FAILED',
  NOT_COMPLETED = 'NOT_COMPLETED'
}

export type ScreeningQuestionOutcome = {
  screeningQuestion: string;
  questionOutcome: ScreeningQuestionOutcomeType;
  responseSummary?: string | null;
};

export type OpenQuestionRequirementOutcome = {
  content: string;
  isMet: boolean;
  evidence: string;
};

export type OpenQuestionOutcome = {
  question: string;
  responseSummary: string;
  openQuestionRequirementOutcomes?: Array<OpenQuestionRequirementOutcome> | null;
  score?: number | null;
};

export type Conversation = {
  id: string;
  userId: string;
  agentId?: string | null;
  campaignId?: string | null;
  twilioParticipantId?: string | null;
  twilioConversationId?: string | null;
  participantPhoneNumber?: string | null;
  participantFirstName?: string | null;
  participantLastName?: string | null;
  participantLinkedInProfile?: string | null;
  messagesCount?: number | null;
  createdAt: string;
  updatedAt: string;
  status: ConversationStatus;
  isRead?: boolean | null;
  messages: {
    items: Message[];
    nextToken?: string;
  };
  pastOngoingConversationId?: string | null;
  pastOngoingConversation?: Conversation | null;
  isWebChatJoined?: boolean | null;
  attachments?: ModelAttachmentConnection | null;
  needsReview?: boolean | null;
  user: User;
  participantEmailAddress?: string | null;
  screeningQuestionsOutcome?: Array<ScreeningQuestionOutcome> | null;
  isHumanTakeover?: boolean | null;
  timeToFirstResponse?: number | null;
  timeToComplete?: number | null;
  repliesCount?: number | null;
  atsCandidateId?: string | null;
  atsApplicationId?: string | null;
  preferredAnswersScore?: number | null;
  openQuestionOutcomes?: Array<OpenQuestionOutcome> | null;
  calendarBooking?: CalendarBooking | null;
  calendarBookingId?: string | null;
};

export type UnansweredQuestion = {
  id: string;
  summary: string;
  isAnswered?: boolean | null;
  conversationId: string;
  campaignId: string;
  associatedMessageId: string;
  associatedMessage?: Message | null;
  createdAt: string;
  updatedAt: string;
};
